<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1500"
      :filename="candidate.name"
      :pdf-quality="1"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="760px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section
        slot="pdf-content"
        class="p-4 f13"
      >
        <section class="pdf-item text-center">
          <h2>Prova da vaga de: {{ job_title }}</h2>
        </section>
        <section class="pdf-item mb-5">
          <span class="d-block">Nome do candidato(a): {{ candidate.name }}</span>
          <span class="d-block">Email do candidato(a): {{ candidate.email }}</span>
          <span class="d-block">Percentual de acertos do Candidato(a): {{ hitsPercentage }} %</span>
        </section>
        <section
          class="pdf-item mt-3"
          v-for="(answer, index) in answers"
          :key="answer.id"
        >
          <div
            class="html2pdf__page-break"
            v-if="index % 5 == 0 && index != 0"
          />

          <div v-if="answer.question.response_type != 0">
            <h4 v-html="answer.question.title">{{ answer.question.title }}</h4>
            <div
              class="mb-2"
              v-if="answer.question.response_type == 2"
            >
              <MultipleChoices
                :answer="answer"
                :useSvg="false"
              />
            </div>
            <div v-if="answer.question.response_type == 4">
              <MonetaryType
                :answer="answer"
                :question="questions[index]"
              />
            </div>
            <div
              class="mb-2"
              v-if="answer.question.response_type == 3"
            >
              <YesOrNo
                :answer="answer"
                :useSvg="false"
              />
            </div>
            <div
              class="mb-2"
              v-if="answer.question.response_type == 1"
            >
              <p
                v-if="answer.choices"
                class="text-justify ml-4"
              >
                {{ answer.choices.text || 'Não respondido' }}
              </p>
              <p
                v-else
                class="text-justify ml-4"
              >
                Não respondido
              </p>
            </div>
          </div>
        </section>
      </section>
    </vue-html2pdf>
    <div
      v-if="answers.filter((answer) => rightType(answer.question)).length > 0"
      class="mt-2 text-right"
      :class="{ 'mb-2': showPreview }"
    >
      <button
        type="button"
        class="btn btn-primary radius-0 to_uppercase"
        @click="generateReport"
      >
        Download da Prova
      </button>
      <button
        type="button"
        class="btn btn-primary radius-0 to_uppercase"
        @click="showPreview = !showPreview"
      >
        {{
          !showPreview
            ? "Mostrar preview da prova"
            : "Esconder preview da prova"
        }}
      </button>
    </div>
    <div
      class="row bg-white p-4 f13"
      v-if="showPreview"
    >
      <div class="col-lg-12 text-center">
        <h2>Prova da vaga de: {{ job_title }}</h2>
      </div>
      <div class="col-lg-12 mb-1">
        <span class="d-block">Nome do candidato(a): {{ candidate.name }}</span>
        <span class="d-block">Email do candidato(a): {{ candidate.email }}</span>
        <span class="d-block">Percentual de acertos do Candidato(a): {{ hitsPercentage }} %</span>
      </div>
      <div
        class="col-lg-12 mt-3"
        v-for="(answer, index) in answers"
        :key="answer.id"
      >
        <div v-if="answer.question.response_type != 0">
          <h4 v-html="answer.question.title">{{ answer.question.title }}</h4>
          <div
            class="mb-2"
            v-if="answer.question.response_type == 2"
          >
            <MultipleChoices
              :answer="answer"
              :useSvg="false"
            />
          </div>
          <div v-if="answer.question.response_type == 4">
            <MonetaryType
              :answer="answer"
              :question="questions[index]"
            />
          </div>
          <div
            class="mb-2"
            v-if="answer.question.response_type == 3"
          >
            <YesOrNo
              :answer="answer"
              :useSvg="false"
            />
          </div>
          <div
            class="mb-2"
            v-if="answer.question.response_type == 1"
          >
            <p class="text-justify ml-4">
              {{ answer.choices.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MultipleChoices from "@/Recruiters/Applies/MultipleChoices.vue";
import MonetaryType from "@/Recruiters/Applies/MonetaryType.vue";
import YesOrNo from "@/Recruiters/Applies/YesOrNo.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  props: ["questions", "answers", "candidate", "job_title", "hitsPercentage"],
  components: { MultipleChoices, MonetaryType, YesOrNo, VueHtml2pdf },
  data: () => ({
    showPreview: false,
  }),
  methods: {
    rightType(question) {
      let excluded_types = [0, 1, 4];
      return !excluded_types.includes(question.response_type);
    },
    async generateReport() {
      await this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>